"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransferProtocol = void 0;
exports.capitalize = capitalize;
exports.lowerFirst = lowerFirst;
exports.equalStrings = equalStrings;
exports.getBreadcrumbName = getBreadcrumbName;
exports.getBreadcrumbs = getBreadcrumbs;
exports.getRandomString = getRandomString;
exports.makeSnakeCase = makeSnakeCase;
exports.stringContainsSubstringCaseInsensitive = stringContainsSubstringCaseInsensitive;
exports.stringValue = stringValue;
exports.getDisplayUrl = getDisplayUrl;
exports.getFullName = getFullName;
exports.getInitials = getInitials;
exports.makeValidUrl = makeValidUrl;
exports.removeQuotes = removeQuotes;
exports.getFilenameFromContentDisposition = getFilenameFromContentDisposition;
exports.isJSON = isJSON;
exports.jsonSafeParse = jsonSafeParse;
exports.getTitleWithCount = getTitleWithCount;
function capitalize(str) {
    if (!str) {
        return str;
    }
    return `${str.charAt(0).toUpperCase()}${str.slice(1)}`;
}
function lowerFirst(str) {
    if (!str) {
        return str;
    }
    return `${str.charAt(0).toLowerCase()}${str.slice(1)}`;
}
function equalStrings(actual, expected) {
    return actual === expected;
}
function getBreadcrumbName(route) {
    return route
        .replaceAll('-', ' ')
        .split(' ')
        .map(capitalize)
        .join(' ');
}
function getBreadcrumbs(route, lookup = {}) {
    var _a;
    const routeMap = {};
    const splitRoute = route.split('/').filter((v) => v.length > 0);
    for (let i = 0; i < splitRoute.length; i += 1) {
        const currentRoute = splitRoute[i];
        const sliceRoutes = splitRoute.slice(0, i + 1);
        const capitalizedRoute = getBreadcrumbName((_a = lookup[currentRoute]) !== null && _a !== void 0 ? _a : currentRoute);
        const routesJoin = sliceRoutes.join('/');
        const routeWithSlashPrepended = `/${routesJoin}`;
        routeMap[routeWithSlashPrepended] = capitalizedRoute;
    }
    return routeMap;
}
function getRandomString(length) {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz1234567890';
    let randomString = '';
    for (let i = 0; i < length; i++) {
        const character = characters.charAt(Math.floor(Math.random() * characters.length));
        randomString += character;
    }
    return randomString;
}
function makeSnakeCase(arr) {
    return arr.join('_');
}
function stringContainsSubstringCaseInsensitive(string, subString) {
    return string.toLowerCase().includes(subString.toLowerCase());
}
function stringValue(str) {
    return str ? str : '';
}
function getDisplayUrl(url) {
    const protocolRegex = /https?:\/\//iu;
    return url.replace(protocolRegex, '');
}
function getFullName(firstName, lastName) {
    return `${stringValue(firstName)} ${stringValue(lastName)}`.trim();
}
function getInitials(firstName, lastName) {
    const firstInitial = stringValue(firstName).charAt(0)
        .toUpperCase();
    const secondInitial = stringValue(firstName).charAt(1)
        .toLowerCase();
    const lastInitial = stringValue(lastName).charAt(0)
        .toUpperCase();
    return `${firstInitial}${lastInitial ? lastInitial : secondInitial}`;
}
var TransferProtocol;
(function (TransferProtocol) {
    TransferProtocol["Http"] = "http://";
    TransferProtocol["Https"] = "https://";
})(TransferProtocol || (exports.TransferProtocol = TransferProtocol = {}));
function makeValidUrl(str, defaultProcotol = TransferProtocol.Http) {
    let url;
    try {
        url = new URL(str);
    }
    catch (_a) {
        return `${defaultProcotol}${str}`;
    }
    return url.protocol && str;
}
function removeQuotes(str) {
    return str.replace(/^"(.+(?="$))"$/u, '$1');
}
function getFilenameFromContentDisposition(contentDisposition) {
    const start = 'attachment; filename=';
    const end = '; filename*';
    const filename = contentDisposition.substring(contentDisposition.indexOf(start) + start.length, contentDisposition.lastIndexOf(end));
    return removeQuotes(filename);
}
function isJSON(input) {
    const rxOne = /^[\],:{}\s]*$/u;
    const rxTwo = /\\(?:["\\/bfnrt]|u[0-9a-fA-F]{4})/gu;
    const rxThree = /"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+-]?\d+)?/gu;
    const rxFour = /(?:^|:|,)(?:\s*\[)+/gu;
    return Boolean(input.length) && rxOne.test(input.replace(rxTwo, '@').replace(rxThree, ']')
        .replace(rxFour, ''));
}
function jsonSafeParse(json) {
    try {
        return JSON.parse(json);
    }
    catch (_a) {
        return undefined;
    }
}
function getTitleWithCount(title, count) {
    return count ? `${title} (${count})` : title;
}
//# sourceMappingURL=lib.js.map